import Swal from 'sweetalert2';
import { mintNFT } from '../../SmartContract/mintNFT';
import { useState } from 'react';
import { recarregarContract } from '../FileUploadBlockchain';
import { blockchainService } from '../../../../services/blockchainService.js';

export const useMintarNft = () => {
  const [fileManagerContract, setFileManagerContract] = useState('');
  const [contractAddressDeploy, setContractAddressDeploy] = useState('');
  const [contractAddressClient, setContractAddressClient] = useState('');
  const [contractWalletOwner, setContractWalletOwner] = useState('');
  const [contractProjectName, setContractProjectName] = useState('');
  const [contractProjectOwner, setContractProjectOwner] = useState('');
  const [contractCar, setContractCar] = useState('');
  const [contractCnpjCpf, setContractCnpjCpf] = useState('');

  const mintarNft = async (
    document_guid,
    document_name,
    file_manager_topic_id,
    item_document_path,
    project_id,
    modelo_GUID,
    headers,
    setData2,
    file_manager_control_id,
  ) => {
    let file_manager_nft_id = null; // 🔹 Declara fora do try

    try {
      // 🔹 Recarregar informações do contrato
      const contractInfo = await recarregarContract(
        project_id,
        headers,
        setFileManagerContract,
        setContractAddressDeploy,
        setContractAddressClient,
        setContractWalletOwner,
        setContractProjectName,
        setContractProjectOwner,
        setContractCar,
        setContractCnpjCpf
      );

      if (!contractInfo) throw new Error('Falha ao carregar informações do contrato');

      const {
        contract_file_manager_contract,
        contract_contract_address_client,
        contract_wallet_owner,
      } = contractInfo;

      if (!contract_file_manager_contract || !contract_contract_address_client || !contract_wallet_owner) {
        throw new Error('Informações do contrato incompletas');
      }

      // 🔹 Confirmação do usuário
      const confirmacao = await Swal.fire({
        title: 'Confirmação',
        text: 'Você realmente deseja mintar a NFT?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar',
      });
      if (!confirmacao.isConfirmed) return;

      // 🔹 Preparar dados para NFT
      const dominio_site = 'http://teste.com.br/';
      const _nftTitle = document_guid;
      const _nftDescription = document_name;
      const _nftPrice = 1;
      const _nftRoyaltyPercentage = 1;
      const _nftImageUrl = dominio_site + item_document_path;

      const requestData = {
        document_id: document_guid,
        project_id,
        contract_id: contract_file_manager_contract,
        topic_id: file_manager_topic_id,
        title: _nftTitle,
        description: _nftDescription,
        price: String(_nftPrice),
        royalty: String(_nftRoyaltyPercentage),
        img_url: _nftImageUrl,
      };

      // 🔹 Inserir NFT via blockchainService
      console.log("📤 Inserindo NFT no backend...");
      const response1 = await blockchainService.insertFileManagerNft(requestData, headers);
      file_manager_nft_id = response1.id; // 🔹 Agora essa variável está acessível no catch também
      console.log("✅ NFT inserida com ID:", file_manager_nft_id);

      // 🔹 Mintar na blockchain
      const retorno = await mintNFT(
        contract_contract_address_client,
        contract_wallet_owner,
        _nftTitle,
        _nftDescription,
        _nftPrice,
        _nftRoyaltyPercentage,
        _nftImageUrl,
        file_manager_nft_id
      );

      // 🔹 Atualizar JSON response NFT
      await blockchainService.atualizarJsonResponseNft(
        retorno.file_manager_nft_id,
        retorno,
        retorno.contratoAddress,
        retorno.contratoClienteAddress,
        retorno.signerGeral,
        retorno.tokenId,
        retorno.signer,
        retorno.signature,
        retorno.hashedMessage,
        headers
      );

      // 🔹 Atualizar data2 NFT
      await blockchainService.atualizarData2Nft(retorno, headers);

      // 🔹 Identificar origem do documento
      let tabelaOrigem = null;
      try {
        const response = await blockchainService.identifyDocument(document_guid, headers);
        tabelaOrigem = response?.table;
      } catch (error) {
        console.error("⚠️ Erro ao identificar tabela do documento:", error);
      }

      // 🔹 Atualizar conforme origem
      if (tabelaOrigem === "merge") {
        await blockchainService.updateMinted(document_guid, headers);
        console.log("✅ Documento de merge marcado como mintado.");
      } else if (tabelaOrigem === "document") {
        await blockchainService.atualizarNftButton(file_manager_control_id, headers);
        await blockchainService.recarregarTela(modelo_GUID, project_id, headers, setData2);
        console.log("✅ Documento individual marcado como mintado.");
      } else {
        console.warn("⚠️ Não foi possível identificar a tabela do documento.");
      }

      Swal.fire({
        title: 'Sucesso!',
        text: 'NFT - Gerada com sucesso!',
        icon: 'success',
        confirmButtonText: 'OK',
      });
    } catch (error) {
      console.error('❌ Erro inesperado ao mintar NFT:', error);

      if (file_manager_nft_id) {
        await blockchainService.atualizaCampoErroNft(
          file_manager_nft_id,
          error.signer,
          error.signature,
          error.hashedMessage,
          error,
          headers
        );
      }

      Swal.fire({
        title: 'Erro!',
        text: 'Algo deu errado ao tentar criar a NFT. Verifique a carteira MetaMask.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };

  return {
    mintarNft,
    fileManagerContract,
    contractAddressDeploy,
    contractAddressClient,
    contractWalletOwner,
    contractProjectName,
    contractProjectOwner,
    contractCar,
    contractCnpjCpf,
  };
};

